module.exports = function() {
  return new Worker(__webpack_public_path__ + "862a7c293452c6316829.worker.js");
};